import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// ?safe&utm_source=FB&country=US&area=female&exp=web_revisit_last_section_female~1
			funnel: {
				id: 'ob-female-funnel-revisit-last',
				locale: ['en'],
			},
		},
	},
]

export default config
